import React, { memo } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

const CollectionIcon = ({ className }) => (
  <SvgIcon
    viewBox="0 0 16 16"
    className={className}
    fill="none"
    width="16"
    height="16"
  >
    <mask
      id="mask0_1_9009"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0_1_9009)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.27933 11.5847L2.03333 2.66667H0.666667C0.489333 2.66667 0.32 2.59667 0.195333 2.47133C0.07 2.34667 0 2.17667 0 2C0 1.632 0.298 1.33333 0.666667 1.33333H2.96667L6.61267 11.35C7.17333 11.4173 7.67267 11.6833 8.03867 12.0753L15.544 9.344L16 10.5967L8.634 13.2773C8.65533 13.404 8.66667 13.534 8.66667 13.6667C8.66667 14.9547 7.62067 16 6.33333 16C5.04533 16 4 14.9547 4 13.6667C4 12.758 4.52067 11.97 5.27933 11.5847ZM6.33333 12.792C6.816 12.792 7.208 13.184 7.208 13.6667C7.208 14.1493 6.816 14.542 6.33333 14.542C5.85 14.542 5.458 14.1493 5.458 13.6667C5.458 13.184 5.85 12.792 6.33333 12.792ZM15.2093 8.45067L7.59733 11.2213L5.77333 6.20933L13.3853 3.43867L15.2093 8.45067ZM9.40267 6.30733L7.48267 7.006L8.39467 9.512L13.5007 7.654L12.5887 5.148L10.6553 5.85133L11.1113 7.104L9.85867 7.56067L9.40267 6.30733ZM11.184 3.53067L5.54533 5.58267L4.26067 2.052L9.89867 0L11.184 3.53067ZM9.102 1.70867L5.96933 2.84933L6.34267 3.874L9.47467 2.734L9.102 1.70867Z"
        fill="white"
      />
    </g>
  </SvgIcon>
);

export default memo(CollectionIcon);
